import { SpriteColorIcon } from 'components/IconColored/IconColored';
import { SpriteIcon } from 'types/icons';

export type LanguageLevelInt = 0 | 1 | 2 | 3 | 4;

export const LANG_LEVEL_TO_ICON_NAME: { [id: number]: SpriteIcon } = {
    0: 'language-beginner',
    1: 'language-intermediate',
    2: 'language-advanced',
    3: 'language-fluent',
    4: 'language-native',
};

export const LANG_LEVEL_TO_ICON_COLORED_NAME: { [id: number]: SpriteColorIcon } = {
    0: 'language-beginner-colored',
    1: 'language-intermediate-colored',
    2: 'language-advanced-colored',
    3: 'language-fluent-colored',
    4: 'language-native-colored',
};
